import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles }) => {
    const userData = sessionStorage.getItem('user');
    let token = null;
    const { CATEGORY, isAuthenticated } = useSelector((state) => state.login);
    const Authenticated = sessionStorage.getItem('isAuthenticated');
    let StoredCategory = sessionStorage.getItem("userCate");
    if (StoredCategory) {
        try {
            StoredCategory = JSON.parse(StoredCategory);
        } catch {
            // Fallback if JSON parsing fails
            StoredCategory = StoredCategory.replace(/^"(.*)"$/, '$1');
        }
    }
    const currentCategory = (CATEGORY ?? StoredCategory)?.trim();
    const normalizedAllowedRoles = allowedRoles.map(role => role.trim());
    if (!(isAuthenticated ? isAuthenticated : Authenticated)) return <Navigate to="/" />;


    if (!normalizedAllowedRoles.includes(currentCategory)) {
        return <Navigate to="/unauthorized" />;
    }
    // if (!allowedRoles.includes(CATEGORY ? CATEGORY : StoredCategory)) return <Navigate to="/unauthorized" />;

    try {
        const parsed = userData ? JSON.parse(userData) : null;
        token = parsed;
    } catch (err) {
        console.error("Invaild user data :", err);
    }

    if (!token) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;